export default "__VITE_ASSET__dRlhv4wg__"